module.exports = __webpack_public_path__ + "img/DNA.68001ebb.png";